// extracted by mini-css-extract-plugin
export default {"root":"picture-block_root__1cSsI","showPicture":"picture-block_showPicture__+GTzE"};